module.exports = __webpack_public_path__ + "img/confetti.1b0e571f.svg";